export default {"src":"/_next/static/media/Apps.16e4dd85.svg","height":16,"width":16};